import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    loading: true,
    isDarkMode: localStorage.getItem('theme') === 'dark',
    currentLanguage: localStorage.getItem('language') || 'ca',
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    toggleDarkMode(state) {
      state.isDarkMode = !state.isDarkMode;
      localStorage.setItem('theme', state.isDarkMode ? 'dark' : 'light');
    },
    setLanguage(state, lang) {
      state.currentLanguage = lang;
      localStorage.setItem('language', lang);
    },
  },
  actions: {
  },
  getters: {
    loading(state) {
      return state.loading;
    },
  },
  modules: {},
});
